/*
 * @Date: 2022-07-04 17:35:11
 * @LastEditors: chuhongguang
 */
export default {
  companyProfile: "公司簡介",
  desc1: '我們是中國最大的DaaS（設備即服務）提供商、中國第壹家構建數字化、多場景閉環DaaS業務模式的公司，在DaaS行業市場份額約為3.9%。DaaS作為壹種新興的企業發展趨勢，將辦公環境輕資產、實現可靠高效設備生命周期管理成為可能。設備生命周期管理包括壹系列廣泛的解決方案，涵蓋IT設備整個生命周期的主要階段，即采購、維護、管理和處置，旨在提高企業對設備的運營效率。根據CIC調研，與傳統做法相比，DaaS幫助企業在三年內將運營成本降低約10%-30%我們以客戶為導向的價值觀指導我們為企業提供低成本、高質量、量身定制的壹站式綜合服務解決方案。',
  des2: ' 自成立以來，我們通過幫助企業降低運營成本，實現綠色經濟和共享經濟、提高IT設備的全生命周期利用率，樹立了良好的企業形象。集團榮獲“國家中小企業公共服務示範平臺”，在2019年，被評為專精特新“小巨人”企業。我們接下來將進壹步倡導壹個充滿活力的企業生態系統。',
  announcementsCirculars: '公告與通函',
  financialPerformance: '財報業績',
  more: '閱讀更多'
}